export default "__VITE_ASSET__D1acpl0e__"